import type { FC, ReactNode } from 'react'
import type { ProductSummary } from '@/types'

import Link from 'next/link'
import { cms } from '@/lib/cms'
import { formatPrice } from '@/lib/format'
import { MediaImage } from '@/components/generals/media-image'

interface ProductCardProps {
    product: ProductSummary
    sizes?: string
}

export const ProductCard: FC<ProductCardProps> = ({ product, sizes = '(min-width: 1280px) 25vw, (min-width: 768px) 33vw, 50vw' }): ReactNode => {
    return (
        <article className='group h-full'>
            <Link href={`/products/${product.slug}`} className='block h-full'>
                <div className='relative aspect-[3/4] overflow-hidden bg-muted'>
                    <MediaImage
                        src={product.image}
                        alt={product.imageAlt}
                        sizes={sizes}
                        className='object-cover transition-transform duration-[1400ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.04]'
                    />
                </div>

                <div className='mt-4 flex flex-col gap-1 pr-2'>
                    <h3 data-mdlfy-cms={cms('products', product.id, 'name')} className='font-heading text-[1.3rem] leading-snug'>
                        {product.name}
                    </h3>

                    {product.tagline && (
                        <p data-mdlfy-cms={cms('products', product.id, 'tagline')} className='text-[13px] leading-snug text-muted-foreground'>
                            {product.tagline}
                        </p>
                    )}

                    <p className='mt-1 text-[13px] tracking-wide'>
                        {formatPrice(product.price)}
                    </p>
                </div>
            </Link>
        </article>
    )
}
